import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import sanitizeHTML from '../../../utils/sanitiseHTML';
import Calendly from '../../Calendly';

const Autoschedule = ({ data }) => {
  const [activeProductIndex, setActiveProductIndex] = useState(null);
  const router = useRouter();
  const dealID = router.query.id ? router.query.id : '';

  const openBooking = (index) => {
    console.log('index', index);
    if (activeProductIndex === index) {
      setActiveProductIndex(null);
    } else {
      setActiveProductIndex(index);
    }
  };

  useEffect(() => {
    if (router.isReady && router.asPath === '/book-your-consultation') {
      if (!dealID) {
        router.push('/book-your-paid-consultation');
      }
    }
  }, [dealID, router]);
  return (
    <div className="section__autoschedule">
      {data.options.map((option, key) => (
        <div className="section__autoschedule__options" key={key}>
          <div className="section__autoschedule__option">
            <img src={option?.image?.sourceUrl} width="100%" height="auto" alt="option-image" />
            <div>
              <h3>{option?.title}</h3>
              <div
                className="subtitle_1"
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(option?.description) }}
              />
            </div>
          </div>
          {option?.products.map((product, key) => (
            <div>
              {product?.buttonLink || product?.paypalButtonLink ? (
                <div className="section__autoschedule__options__products" key={key}>
                  <p>{product?.title}</p>
                  <p>{product?.price}</p>
                  <p>
                    <div className="section__autoschedule__buttons">
                      {product?.buttonLink ? (
                        <div className="section__autoschedule__buttons__single">
                          <a
                            onClick={() => openBooking(product?.buttonLink)}
                            className="button card"
                          >
                            Book now
                          </a>
                          <strong>(Pay by card)</strong>
                        </div>
                      ) : (
                        ''
                      )}
                      {product?.paypalButtonLink ? (
                        <div className="section__autoschedule__buttons__single">
                          <a
                            onClick={() => openBooking(product?.paypalButtonLink)}
                            className="button paypal"
                          >
                            <img className="" src="/images/paypal_button.png" alt="Paypal" />
                          </a>
                          <strong>(Instalments available)</strong>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </p>
                </div>
              ) : (
                ''
              )}
              {activeProductIndex &&
                (activeProductIndex === product?.buttonLink ||
                  activeProductIndex === product?.paypalButtonLink) && (
                  <Calendly link={activeProductIndex} dealID={dealID} />
                )}
            </div>
          ))}
        </div>
      ))}
      {data.bottomText && (
        <div
          className="subtitle_1"
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(data?.bottomText) }}
        />
      )}
    </div>
  );
};

export default Autoschedule;
